(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlBool', [])
        .directive('dynamicBool', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-bool/custom-control-bool-template.html'
            };
        });

    angular.module('CustomControlBool')
        .directive('dynamicFilterBool', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-bool/custom-control-filter-bool-template.html'
            };
        });
})();